import React from 'react';

import cx from 'classnames';

import styles from './PeriodSelector.module.scss';

import { MetadataPillSeparator } from '~/components/Matchmaking/screens/MetadataPillSeparator';

export type TPeriodSelectorOption<T extends string> = {
  value: T;
  label: React.ReactNode;
  testId?: string;
};

export type TPeriodSelectorProps<T extends string> = {
  value: T;
  options: readonly TPeriodSelectorOption<T>[];
  onChange: (value: T) => void;
  disabled?: boolean;
  className?: string;
};

export function PeriodSelector<T extends string>({
  className,
  disabled = false,
  onChange,
  options,
  value,
}: TPeriodSelectorProps<T>) {
  return (
    <div className={cx(styles.periodSelector, className)} role="tablist">
      {options.map((option, idx) => (
        <React.Fragment key={option.value}>
          <button
            aria-selected={value === option.value}
            className={cx(
              styles.periodButton,
              value === option.value && styles.periodButtonActive,
            )}
            data-testid={option.testId}
            disabled={disabled}
            onClick={() => {
              onChange(option.value);
            }}
            role="tab"
            type="button"
          >
            {option.label}
          </button>
          {idx < options.length - 1 ? <MetadataPillSeparator /> : null}
        </React.Fragment>
      ))}
    </div>
  );
}
